export const blurFadeStyle = (index: number) => ({
  opacity: 0,
  filter: "blur(4px)",
  transform: "translateY(10px)",
  animation: `blurIn 500ms ease-out forwards`,
  animationDelay: `${index * 300}ms`,
  "@keyframes blurIn": {
    "0%": {
      filter: "blur(4px)",
      opacity: 0,
      transform: "translateY(10px)",
    },
    "30%": {
      filter: "blur(0)",
      opacity: 0.5,
    },
    "100%": {
      filter: "blur(0)",
      opacity: 1,
      transform: "translateY(0)",
    },
  },
});
